var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "home_page" },
    [
      _c("Menu", { attrs: { menuList: _vm.menuList } }),
      _c(
        "section",
        { class: [_vm.collapsed ? "secwidth80" : "secwidth180"] },
        [
          _c("Header"),
          _c("div", { staticClass: "content_box" }, [
            _c(
              "div",
              { staticClass: "router_list" },
              [
                _c("Label", {
                  attrs: { left: _vm.labelLeft },
                  on: {
                    "update:left": function ($event) {
                      _vm.labelLeft = $event
                    },
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "content_view" },
              [
                _c(
                  "keep-alive",
                  { attrs: { include: _vm.keepArr } },
                  [_c("router-view")],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }